import { z } from "zod";
// Общая схема для Manufacturer
export const zManufacturerCommonSchema = z.object({
    id: z.string(),
    name: z.string(),
    contactPerson: z.string().nullish(),
    contactPhone: z.string().nullish(),
    contactEmail: z.string().nullish(),
    website: z.string().nullish(),
    address: z.string().nullish(),
    notes: z.string().nullish(),
    idCreatedBy: z.string().nullish(),
    idUpdatedBy: z.string().nullish(),
    isDeleted: z.boolean().nullish(),
});
export const zManufacturerFiltersSchema = z.object({
    search: z.string().optional(),
});
